import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getSession, isAuthenticated } from "../utils/auth";

export default function ProtectedRoute({ children, adminOnly = false }) {
  const location = useLocation();
  if (!isAuthenticated()) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  const session = getSession();

  // Force password change before accessing any other protected page
  if (session?.mustChangePassword && location.pathname !== "/change-password") {
    return <Navigate to="/change-password" replace />;
  }

  if (adminOnly && !session?.isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
